// extracted by mini-css-extract-plugin
module.exports = {"sideBar":"Pesticides_sideBar__NudJT","spinner":"Pesticides_spinner__3OSxc"};